import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <div data-testid="auth-layout" className="flex min-h-dvh items-center justify-center bg-background px-4 py-8 dark:bg-background">
      <main className="w-full max-w-[480px]">
        <Outlet />
      </main>
    </div>
  );
}
